import React, { PureComponent } from 'react';
import TarjetaHeader from "./TarjetaHeader.jsx";
import MontoMask from "../../../../Common/Components/Mask/MontoMask.jsx"
import DateMask from "../../../../Common/Components/Mask/DateMask.jsx"

class TarjetaItem extends PureComponent {
    constructor(props) {
        super(props)
    }

    render() {
        let component = null;

        const { data } = this.props;

        let monto = null;
        let establecimientoCuotas = null;

        let nombreEstablecimiento = data.NumeroEstablecimiento ? data.NumeroEstablecimiento : (data.MonedaOrigenId == 1 ? "Consumo en pesos" : "Consumo en dolares");

        establecimientoCuotas = data.EstadoCuotas != '' && data.NumeroCuotasPlan > 1 ? nombreEstablecimiento + " " + data.EstadoCuotas : nombreEstablecimiento;
        monto = data.DebitoCredito == 1 ? (-1 * data.ImporteCuota.toFixed(2)) : data.ImporteCuota.toFixed(2);

        const algo = this.props.i % 2;

        return (
            <div style={{ height: "50px", width: "100%", "line-height":"45px", backgroundColor: (algo == 0 ? "white" : "#d1fcdb") }}>
                <div className="col-xs-3 text-left">
                    <label className="label-primary"> <DateMask fecha={data.FechaOrigen} /></label>
                </div>
                <div className="col-xs-5 text-left">
                    {data.DebitoCredito == 1 ? data.AjusteMotivoDescripcion : establecimientoCuotas}
                </div>
                <div className="col-xs-2 text-right">
                    {data.MonedaOrigenId == 1 ? <MontoMask monto={monto} moneda="" class="label-primary" /> : <label className="label-primary text-right" > 0.00 </label>}
                </div>
                <div className="col-xs-2 text-right">
                    {data.MonedaOrigenId == 2 ? <MontoMask monto={monto} moneda="" class="label-primary" /> : <label className="label-primary text-right" > 0.00 </label>}
                </div>
            </div>
        );


        return (
            <div className="row no-margin">
                {component}
            </div>
        );
    }
}

export default TarjetaItem;